var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showError)?_c('div',{staticClass:"bg-danger text-white text-center p-6 fixed w-full md:w-3/5 lg:w-4/5 right-0 bottom-0 errorbox"},_vm._l((_vm.errors),function(e){return _c('p',[_vm._v(_vm._s(_vm.formattedError(e)))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }